export default __webpack_public_path__ + "static/media/team-events.b66c2a1a.svg";